import {
  PLATFORM_URLS,
  type DeploymentTier,
  type PlatformKey,
} from '../constants/platformUrls';

const stripTrailingSlash = (url: string) => url.replace(/\/$/, '');

const isTier = (v: string | undefined): v is DeploymentTier =>
  v === 'local' || v === 'dev' || v === 'prod';

export const inferClientDeploymentTier = (): DeploymentTier => {
  const forced = process.env.REACT_APP_DEPLOYMENT_TIER;
  if (isTier(forced)) {
    return forced;
  }

  if (typeof window === 'undefined') {
    return 'prod';
  }

  const hostname = window.location.hostname.toLowerCase();

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'local';
  }

  if (
    hostname.includes('submission-v2') ||
    hostname.includes('curator-dev') ||
    hostname.includes('api-curator-dev')
  ) {
    return 'dev';
  }

  return 'prod';
};

const getPlatformBaseUrl = (platform: PlatformKey) => {
  const tier = inferClientDeploymentTier();
  const defaults = PLATFORM_URLS[tier][platform];

  // URL overrides: prod always; dev only for builds that opt in via REACT_APP_DEPLOYMENT_TIER (old builds unchanged).
  if (tier === 'prod' || (tier === 'dev' && isTier(process.env.REACT_APP_DEPLOYMENT_TIER))) {
    const envOverride =
      platform === 'curator'
        ? process.env.REACT_APP_URL_CURATOR_PLATFORM
        : process.env.REACT_APP_URL_ARTIST_PLATFORM;

    if (envOverride) {
      return stripTrailingSlash(envOverride);
    }
  }

  return defaults;
};

export const getArtistPlatformLoginUrl = () => getPlatformBaseUrl('artist');

export const getCuratorPlatformLoginUrl = () => {
  const base = getPlatformBaseUrl('curator');
  return `${base}/?openLogin=true`;
};

export const getCuratorPlatformBaseUrl = () =>
  getCuratorPlatformLoginUrl().replace('/?openLogin=true', '');
